import { FiscalYear } from 'app/internal/shared/models/fiscal-year';
import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { getSelectedFiscalYear } from '../../../property/property-store/property.selectors';

@Component({
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false
})

export class SetupMainComponent {

  selectedFiscalYear$: Observable<FiscalYear>;

  constructor(private store: Store<AppState>) {
    this.selectedFiscalYear$ = this.store.pipe(select(getSelectedFiscalYear));
  }
}
